import * as React from 'react';

import classNames from 'classnames';
import URI from 'jsuri';
import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';
import { compose } from 'underscore';
import FluxibleComponent from 'vendor/cnpm/fluxible.v0-4/addons/FluxibleComponent';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import connectToRouter from 'js/lib/connectToRouter';
import Retracked from 'js/lib/retracked';

import { loadSessionsForCourse, loadSessionsForUnprivileged } from 'bundles/discussions/actions/SessionFilterActions';
import app from 'bundles/discussions/app';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import ThreadDetail from 'bundles/discussions/components/discussionsBody/ThreadDetail';
import ThreadsList from 'bundles/discussions/components/discussionsBody/ThreadsList';
import SearchResults from 'bundles/discussions/components/search/SearchResults';
import { defaults } from 'bundles/discussions/constants';

import _t from 'i18n!nls/discussions';

class DiscussionsBody extends React.Component {
  static propTypes = {
    backLink: PropTypes.string,
    className: PropTypes.string,

    // Routing parameters - can be overwritten from router
    questionId: PropTypes.string,
    answerId: PropTypes.string,
    commentId: PropTypes.string,
    sort: PropTypes.string,
    page: PropTypes.number,
    detailSort: PropTypes.string,
    detailPage: PropTypes.number,
    listSort: PropTypes.string,
    listPage: PropTypes.number,
    q: PropTypes.string,
    searchPage: PropTypes.number,
    fluxibleContext: PropTypes.object,

    // Flags for setting up stores that child components will depend on
    courseId: PropTypes.string,
    currentSessionId: PropTypes.string,
    hasModerationRole: PropTypes.bool,
    isPrivateSession: PropTypes.bool,
    isSessionsFilterStoreSetup: PropTypes.bool,
  };

  static contextTypes = {
    router: PropTypes.object.isRequired,
    fluxibleContext: PropTypes.object,
    executeAction: PropTypes.func.isRequired,
  };

  declare context: LegacyContextType<typeof DiscussionsBody.contextTypes>;

  static childContextTypes = {
    fluxibleContext: PropTypes.object,
  };

  static defaultProps = {
    detailSort: defaults.detailSort,
    detailPage: defaults.detailPage,
    listSort: defaults.listSort,
    listPage: defaults.listPage,
  };

  state = {};

  getChildContext() {
    return {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'fluxibleContext' does not exist on type ... Remove this comment to see the full error message
      fluxibleContext: this.context.fluxibleContext || this.props.fluxibleContext,
    };
  }

  constructor(props: $TSFixMe, context: $TSFixMe) {
    super(props, context);

    /**
     * If sessionfilter store has not been loaded from a parent component then
     *  Load Session data so that SessionFilterStore is setup correctly for
     *  all thread related components (ThreadsList,ThreadDetail, SearchResults)
     */

    if (!props.isSessionsFilterStoreSetup && props.hasModerationRole) {
      context.executeAction(loadSessionsForCourse, {
        courseId: props.courseId,
        currentSessionId: props.currentSessionId,
        isPrivateSession: props.isPrivateSession,
      });
    }

    if (!props.isSessionsFilterStoreSetup && !props.hasModerationRole) {
      context.executeAction(loadSessionsForUnprivileged, {
        courseId: props.courseId,
        currentSessionId: props.currentSessionId,
        isPrivateSession: props.isPrivateSession,
      });
    }
  }

  componentWillReceiveProps(nextProps: $TSFixMe) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'questionId' does not exist on type 'Read... Remove this comment to see the full error message
    if (!this.props.questionId && nextProps.questionId && this.props.listPage) {
      this.setState({
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'listPage' does not exist on type 'Readon... Remove this comment to see the full error message
        previousListPage: this.props.listPage,
      });
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'questionId' does not exist on type 'Read... Remove this comment to see the full error message
    } else if (this.props.questionId !== nextProps.questionId) {
      this.setState({
        previousListPage: null,
      });
    }
  }

  renderSearchResults() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'searchPage' does not exist on type 'Read... Remove this comment to see the full error message
    const { searchPage, q } = this.props;
    return (
      // @ts-expect-error ts-migrate(2739) FIXME: Type '{ query: any; page: any; ref: (input: Compon... Remove this comment to see the full error message
      <SearchResults
        query={q}
        page={searchPage}
        ref={(input) => {
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'searchResults' does not exist on type 'D... Remove this comment to see the full error message
          this.searchResults = input;
        }}
      />
    );
  }

  renderThreadsList() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'hasModerationRole' does not exist on typ... Remove this comment to see the full error message
    const { hasModerationRole, listPage, listSort } = this.props;
    return (
      <ThreadsList
        ref={(input: $TSFixMe) => {
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'threadsList' does not exist on type 'Dis... Remove this comment to see the full error message
          this.threadsList = input;
        }}
        hasModerationRole={hasModerationRole}
        sort={listSort}
        page={listPage}
      />
    );
  }

  renderThreadDetail() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'questionId' does not exist on type 'Read... Remove this comment to see the full error message
    const { questionId, answerId, commentId, detailPage, detailSort, listSort, listPage, q, backLink } = this.props;

    const fullBackLink = new URI(backLink)
      .addQueryParam('sort', listSort)
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'previousListPage' does not exist on type... Remove this comment to see the full error message
      .addQueryParam('page', this.state.previousListPage || listPage)
      .addQueryParam('q', q)
      .toString();

    return (
      <ThreadDetail
        ref={(input: $TSFixMe) => {
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'threadDetail' does not exist on type 'Di... Remove this comment to see the full error message
          this.threadDetail = input;
        }}
        questionId={questionId}
        answerId={answerId}
        commentId={commentId}
        sort={detailSort}
        page={detailPage}
        backLink={fullBackLink}
      />
    );
  }

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'q' does not exist on type 'Readonly<{}> ... Remove this comment to see the full error message
    const searchQuery = this.props.q;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'role' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    const { role, questionId } = this.props;

    return (
      <div
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'className' does not exist on type 'Reado... Remove this comment to see the full error message
        className={classNames('rc-DiscussionsBody', 'styleguide', this.props.className)}
        id="discussions-tabpanel"
        aria-label={_t('Discussions')}
        {...(role ? { role } : {})}
      >
        {questionId && this.renderThreadDetail()}
        {!questionId && (searchQuery ? this.renderSearchResults() : this.renderThreadsList())}
      </div>
    );
  }
}

const getPropsFromRouter = (router: $TSFixMe, props = {}) => {
  const params = router.params;
  const query = router.location.query;

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'questionId' does not exist on type '{}'.
  const questionId = params.question_id || props.questionId;
  const page = query.page ? parseInt(query.page, 10) : 1;

  const newProps = {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'answerId' does not exist on type '{}'.
    answerId: params.answer_id || props.answerId,
    questionId,
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'commentId' does not exist on type '{}'.
    commentId: params.comment_id || props.commentId,
    sort: query.sort,
    page,
  };

  if (questionId) {
    Object.assign(newProps, {
      detailSort: query.sort,
      detailPage: page,
    });
  } else if (query.q) {
    Object.assign(newProps, {
      // TODO: NOTE This might be weird ... revisit whether or not this q goes out of sync.
      q: query.q,
      searchPage: page,
    });
  } else {
    Object.assign(newProps, {
      listSort: query.sort,
      listPage: page,
    });
  }

  return newProps;
};

const ConnectedDiscussionsBody = compose(
  connectToStores(
    ['SessionFilterStore', 'SessionStore', 'CourseStore', 'CourseMembershipStore', 'ApplicationStore'],
    ({ SessionFilterStore, SessionStore, CourseStore, CourseMembershipStore, ApplicationStore }, props) => {
      return {
        hasModerationRole: CourseMembershipStore.hasModerationRole() || ApplicationStore.isSuperuser(),
        isSessionsFilterStoreSetup: SessionFilterStore.filtersLoaded,
        currentSessionId: SessionStore.isEnrolled() ? SessionStore.getSessionId() : undefined,
        courseId: CourseStore.getCourseId(),
        isPrivateSession: SessionStore.isEnrolled() ? SessionStore.isSessionPrivate() : false,
      };
    }
  ),
  connectToRouter(getPropsFromRouter),
  Retracked.createTrackedContainer((props) => {
    return {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'sort' does not exist on type '{}'.
      sort: props.sort,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'page' does not exist on type '{}'.
      page: props.page,
    };
  })
)(DiscussionsBody);

export default class FluxibleConnectedDiscussionsBody extends React.Component {
  static contextTypes = {
    fluxibleContext: PropTypes.object,
  };

  declare context: LegacyContextType<typeof FluxibleConnectedDiscussionsBody.contextTypes>;

  componentWillMount() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'fluxibleContext' does not exist on type ... Remove this comment to see the full error message
    this.fluxibleContext = app(this.context.fluxibleContext);
  }

  render() {
    return (
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'fluxibleContext' does not exist on type ... Remove this comment to see the full error message
      <FluxibleComponent context={this.fluxibleContext.getComponentContext()}>
        <ConnectedDiscussionsBody {...this.props} />
      </FluxibleComponent>
    );
  }
}
